/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetWinnersRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetWinnersArgs, useGetWinnersSpec, useGetWinnersRealtime, useGetWinnersPagination } from '../specs/winners.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetWinnersRow } from '../openapi-types.gen.js';
export type { useGetWinnersArgs } from '../specs/winners.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetWinnersPaginationContract = useGetWinnersPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetWinnersInfinite` — both
 * read/write the same `PagedData<GetWinnersRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): limit, pubkeys, category, marketCapMin, marketCapMax, liquidityMin, liquidityMax, volumeMin, volumeMax, holdersMin, holdersMax, change24hMinBps, change24hMaxBps, graduatedAfter, graduatedBefore, sortBy, sortOrder, cursor.
 */
const _useGetWinners = createListHook({
  spec: useGetWinnersSpec,
  realtime: useGetWinnersRealtime,
  entityKey: 'outcome',
  pagination: _useGetWinnersPaginationContract,
});
export const useGetWinners = _useGetWinners as (args: useGetWinnersArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetWinners>;


/**
 * Auto-infinite: same cache as `useGetWinners`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetWinners` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetWinnersInfinite = createListHook({
  spec: useGetWinnersSpec,
  realtime: useGetWinnersRealtime,
  entityKey: 'outcome',
  pagination: _useGetWinnersPaginationContract,
  autoLoadMore: true,
});
export const useGetWinnersInfinite = _useGetWinnersInfinite as (args: useGetWinnersArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetWinnersInfinite>;


/**
 * Per-field subscription hook for the `useGetWinners` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetWinnersField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetWinnersField = createFieldHook<GetWinnersRow>('useGetWinnersField');

/**
 * Hover/intent prefetch companion for `useGetWinners` (also covers
 * `useGetWinnersInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetWinners();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetWinners = createPrefetchHook(useGetWinnersSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetWinnersArgs>;
